module.exports = {
  settings: {
    nativeApp: 'android',
    social: {
      displayTwitter: true,
      displayFacebook: true,
    },
  },
};
